export const REQUEST_HOMEPAGE = "REQUEST_HOMEPAGE";
export const RECEIVED_HOMEPAGE = "RECEIVED_HOMEPAGE";
export const ERROR_HOMEPAGE = "ERROR_HOMEPAGE";

export const HOMEPAGE_NONE = "HOMEPAGE_NONE";
export const HOMEPAGE_REQUESTING = "HOMEPAGE_REQUESTING";
export const HOMEPAGE_RECEIVED = "HOMEPAGE_RECEIVED";
export const HOMEPAGE_ERROR = "HOMEPAGE_ERROR";
